// extracted by mini-css-extract-plugin
module.exports = {"title":"_4JIzf","rowTitle":"_5gNf5","icons":"_3s6xM","icon":"_2RHpH"};